<div class="position-relative d-flex align-items-center">
    <!-- Center tab buttons -->
    <div class="position-absolute start-50 translate-middle-x">
        <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button" class="tab-button" [class.active]="currentTab === 'table'"
                (click)="onTabChange('table')">
                Table View
            </button>

            <button type="button" class="tab-button" [class.active]="currentTab === 'graph'"
                (click)="onTabChange('graph')">
                Graph View
            </button>
        </div>
    </div>

    <!-- Right-aligned download button -->
    <div class="ms-auto me-3">
        <button class="btn btn-dark rounded" (click)="openDownloadPopup(content)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="me-2">
                <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download Report
        </button>
    </div>
</div>

<ng-container *ngIf="currentTab==='table'">

        <div class="table-pre px-4 d-flex align-items-center justify-content-between">

            <h3>Grid Meter</h3>
            <span class="text-muted fs-6" *ngIf="type17Devices && type17Devices.length>0">Last Fetched:
                {{type17Devices[0]?.collectTime | date : 'short'}}</span>
        </div>
        <div class="table-responsive">
            <table class="table text-center">
                <thead>
                    <tr>
                        <th>DevID</th>
                        <!-- <th *ngFor="let header of getHeaders(type17Devices)">{{ header }}</th> -->
                        <th *ngFor="let header of headersFor17ToDisplay">
                            <!-- {{ header }} -->
                            {{ getHeaderLabel(header) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!isLoadingTable; else LoadingRow">
                        <ng-container *ngIf="type17Devices && type17Devices.length>0 else noRow">
                            <tr *ngFor="let device of type17Devices">
                                <td>{{ device.devId }}</td>
                                <td *ngFor="let header of headersFor17ToDisplay"
                                    [ngStyle]="{background: getValue(device, header) !== null ? '#d1e7dd' : '#f8d7da'}">
                                    {{ device.dataItemMap[header] ?? '—' }}
                                </td>
                                <!-- <td *ngFor="let header of getHeaders(type17Devices)" [ngStyle]="{background: getValue(device, header) !== null ? '#d1e7dd' : '#f8d7da'}">
                            {{ getValue(device, header) ?? '—' }}
                        </td> -->
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="table-pre px-4 d-flex align-items-center justify-content-between mt-5">
            <h3>Power Sensor</h3>
            <span class="text-muted fs-6" *ngIf="type47Devices && type47Devices.length>0">Last Fetched:
                {{type47Devices[0]?.collectTime | date : 'short'}}</span>
        </div>
        <div class="table-responsive">
            <table class="table text-center">
                <thead>
                    <tr>
                        <th>DevID</th>
                        <!-- <th *ngFor="let header of getHeaders(type47Devices)">{{ header }}</th> -->
                        <th *ngFor="let header of headersFor47ToDisplay">
                            <!-- {{ header }} -->
                            {{ getHeaderLabel(header) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!isLoadingTable; else LoadingRow">
                        <ng-container *ngIf="type47Devices && type47Devices.length>0 else noRow">
                            <tr *ngFor="let device of type47Devices">
                                <td>{{ device.devId }}</td>
                                <!-- <td *ngFor="let header of getHeaders(type47Devices)" [ngStyle]="{background: getValue(device, header) !== null ? '#d1e7dd' : '#f8d7da'}">
                            {{ getValue(device, header) ?? '—' }}
                        </td> -->
                                <td *ngFor="let header of headersFor47ToDisplay"
                                    [ngStyle]="{background: getValue(device, header) !== null ? '#d1e7dd' : '#f8d7da'}">
                                    {{ device.dataItemMap[header] ?? '—' }}
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>

</ng-container>
<ng-container *ngIf="currentTab==='graph'">
    <app-wapda-graph></app-wapda-graph>
</ng-container>
<ng-template #noRow>
    <tr>
        <td colspan="100%">
            <div class="fw-semibold text-center">
                No data found
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<!-- <div class="table-responsive">
    <table class="table text-center">
        <thead class="thead-orange">
            <tr>
                <th scope="col">Plants</th>
                <th scope="col">Wind Speed</th>
                <th scope="col">Temprature</th>
                <th scope="col">Radiant Line</th>
                <th scope="col">Radiant Total</th>
                <th scope="col">PV Temprature</th>
                <th scope="col">Horizontal Radiant Line</th>
                <th scope="col">Horizontal Radiant Total</th>
                <th scope="col">Packet Received</th>
                <th scope="col">Distance (KM)</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="!isLoadingTable; else LoadingRow">
                <ng-container *ngIf="wapdaList && wapdaList.length>0 else noRow">
                    <tr>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                        <td>1</td>                       
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>
    </table>
</div> -->
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            WAPDA Generator Report
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 form-styles my-3">
                <label for="downtime">Date</label>
                <div class="form-group input-group daterange-wrapper">
                    <input type="text" class="form-control" bsDatepicker [(ngModel)]="selectedDate"
                        [bsConfig]="datePickerConfig" #dp="bsDatepicker" placeholder="Date" />
                    <div class="input-group-append" (click)="dp.toggle()">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                fill="none">
                                <path
                                    d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                    fill="currentColor" />
                            </svg></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click');">
            Cancel
        </button>
        <button type="submit" class="btn btn-orange" (click)="downloadReport()">
            <ng-container *ngIf="!isDownloading; else downloading">
                Download
            </ng-container>
            <ng-template #downloading>
                <span class="spinner-border spinner-border-sm me-2"></span> Downloading...
            </ng-template>
        </button>
    </div>
</ng-template>